import { EXAM_COURSE_ROUTES } from "../homeDashboard/courses/examCourseRoutes";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import "./Dashboard.css";
import DashboardBannerSlider from "../dashboard/DashboardBannerSlider";
import LogoIcon from "../assets/images/SliderLogo.png";
import examImg from "../assets/images/state-img.png";
import starIcon from "../assets/images/bookmark.png";
import { useExamCategories } from "../hooks/useExamCategories";
import MyWalletSidebar from "../homeDashboard/MyWalletSidebar";

const CARD_LIMIT = 4;

const ExamStateCard = ({ item, onOpen }) => {
  return (
    <Col  xxl={3} xl={6}  lg={3} md={4} sm={6} xs={12} >
      <div
        className="state-card"
        role="button"
        tabIndex={0}
        onClick={onOpen}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onOpen();
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <img src={item.exam_image} className="state-bg" alt={item.exam_name} />

        <div className="state-badge">
          <img src={LogoIcon} alt="" />
        </div>``

        {Number(item.is_favourite) === 1 ? (
          <div className="state-star">
            <img src={starIcon} alt="Favorite exam" />
          </div>
        ) : null}

        {Number(item.is_user_exam) === 1 || Number(item.is_subscribed) === 1 ? (
          <div className="state-tick">
            <i className="fa-solid fa-check"></i>
          </div>
        ) : null}

        <div className="state-content">
          <h5>{item.exam_name}</h5>
          {item.state_name ? <p>({item.state_name})</p> : null}
        </div>
      </div>
    </Col>

  );
};

const ExamSection = ({ title, items = [], emptyMessage, onOpenExam }) => {
  const visibleItems = items.slice(0, CARD_LIMIT);

  return (
    <Col lg={12}>
      <div className="state-heading d-flex justify-content-between align-items-center">
        <h6 className="states-title fw-bold mb-0">{title}</h6>
      </div>

      {visibleItems.length ? (
        <Row className="g-3">
          {visibleItems.map((item) => (
            <ExamStateCard key={item.md_exams_id} item={item} onOpen={() => onOpenExam(item)} />
          ))}
        </Row>
      ) : (
        <p className="quick-action__status">{emptyMessage}</p>
      )}
    </Col>
  );
};

function Exams() {
  const navigate = useNavigate();
  const {
    data: examCategoriesData,
    isLoading,
    isError,
    error,
  } = useExamCategories();

  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load exams."
    : "";
  const openMasterExam = (item) => {
    navigate(EXAM_COURSE_ROUTES.plans, {
      state: {
        md_exam_id: Number(item?.md_exams_id || 0),
        selectedMasterExam: {
          id: Number(item?.md_exams_id || 0),
          name: item?.exam_name || "Exam",
          image: item?.exam_image || "",
        },
      },
    });
  };

  return (
      <>
      {/* Page Height Setup */}

      <style>
        {`      
    @media  (max-width: 576px){
       .dashboard-states .state-card {
          height: 125px !important;
    }
        }
      
        `}
      </style>
    <HomeDashboardLayout>
      <div className="content-container innerContent">
        <Row className="g-4 align-items-start dashboard-states mt-0">
          <Col md={12} xl={12}>
            <DashboardBannerSlider />
          </Col>

          {isLoading ? <p className="quick-action__status">Loading exams...</p> : null}
          {!isLoading && loadError ? <p className="quick-action__status quick-action__status--error">{loadError}</p> : null}

          {!isLoading && !loadError ? (
            <>
              <ExamSection
                title="Subscribed Exam"
                items={examCategoriesData?.subscribedExams}
                emptyMessage="No subscribed exams available."
                onOpenExam={openMasterExam}
              />
              <ExamSection
                title="Favorite Exam"
                items={examCategoriesData?.favoriteExams}
                emptyMessage="No favorite exams available."
                onOpenExam={openMasterExam}
              />
            </>
          ) : null}
        </Row>

        {!isLoading && !loadError ? (
          <Row className="g-4 align-items-start dashboard-states">
            <ExamSection
              title="My State Exam"
              items={examCategoriesData?.myStateExams}
              emptyMessage="No state exams available."
              onOpenExam={openMasterExam}
            />
            <ExamSection
              title="Other Exams"
              items={examCategoriesData?.otherExams}
              emptyMessage="No other exams available."
              onOpenExam={openMasterExam}
            />
          </Row>
        ) : null}

        {!isLoading && !loadError ? (
          <Row className="g-4 dashboard-states">
            <div className="col-md-12">
              <div className="state-heading d-flex justify-content-between align-items-center">
                <h6 className="states-title fw-bold mb-0">Exam Categories</h6>
              </div>
            </div>

            {examCategoriesData?.categories?.length ? (
              examCategoriesData.categories.map((item) => (
                <div className="col-md-6" key={item.category_id}>
                  <div className="exam-card d-flex align-items-center position-relative exam-border">
                    <div className="examContent d-flex align-items-center justify-content-between w-100 position-relative">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src={item.icon_url || item.image_url || examImg}
                          alt={item.name}
                          className="exam-img"
                        />
                        <div>
                          <h6 className="exam-title mb-0 fw-semibold">{item.name}</h6>
                          <p className="exam-subtitle mb-0">
                            <span className="fw-medium exam-count">
                              {Number(item.exam_count || 0)} Exam
                              {Number(item.exam_count || 0) === 1 ? "" : "s"}
                            </span>
                            <span className="fw-normal exam-selected ms-1">
                              ({Number(item.favorite_count || 0)} favorites)
                            </span>
                          </p>
                        </div>
                      </div>

                      <span className="chevron-btn">
                        <i className="bi bi-chevron-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12">
                <p className="quick-action__status">No exam categories available.</p>
              </div>
            )}
          </Row>
        ) : null}
      </div>
      <MyWalletSidebar />
    </HomeDashboardLayout>
    </>
  );
}

export default Exams;
